export const portfolioData = {
  about: {
    title: "À propos de moi",
    description: "Développeur web passionné...",
    skills: ["React", "JavaScript", "HTML", "CSS", "Node.js"]
  },
  projects: [
    {
      id: 1,
      title: "Projet en C#",
      year: "2023",
      description: "Site en C# afin de pouvoir gérer une interface admin de site d'e-commerce (le panier, l'utilisateur, etc).",
      technologies: ["C#", "ASP.NET", "SQL"]
    },
    {
      id: 2,
      title: "DataBase",
      year: "2023",
      description: "Site pour gérer une database d'une bibliothèque, tout est trié par exemple avec le nom de l'auteur, nom du livre, l'éditeur, l'année etc.",
      technologies: ["SQL", "PHP", "HTML/CSS"]
    },
    {
      id: 3,
      title: "FranceInter",
      year: "2023",
      description: "Site pour gérer le nombre de personnes dans un studio d'enregistrement avec un système d'analyse de personne avec les API de Microsoft Azure, possibilité d'écrire un message en français qui sera diffusé en anglais et français de façon audio.",
      technologies: ["Azure API", "JavaScript", "Node.js"]
    },
    {
      id: 4,
      title: "Jeux Unity",
      year: "2023",
      description: "Jeu sur Unity sur le thème Tom & Jerry. On contrôle la souris, le chat est une IA. Plusieurs niveaux disponibles fait en C#.",
      technologies: ["Unity", "C#", "IA"]
    },
    {
      id: 5,
      title: "Application mobile",
      year: "2023",
      description: "Application mobile d'émargement en Flutter pour notre école. Simple QR Code à scanner en entrée ainsi quand sortie.",
      technologies: ["Flutter", "Dart", "QR Code"]
    },
    {
      id: 6,
      title: "Bot Discord",
      year: "2024",
      description: "Bot Discord développé pour gérer automatiquement les connexions en salon vocal. Permet de suivre les temps de connexion et générer des statistiques d'utilisation.",
      technologies: ["Discord.js", "Node.js", "MongoDB"]
    },
    {
      id: 7,
      title: "Veille Technologique",
      year: "2024",
      description: "Plateforme de veille technologique permettant de suivre les dernières actualités et innovations dans le domaine du développement web et mobile.",
      technologies: ["React", "Node.js", "API REST"]
    },
    {
      id: 8,
      title: "Monstermoon",
      year: "2024",
      description: "Projet de gestion de base de données complexe avec des relations multiples entre les entités. Optimisation des requêtes et mise en place d'index pour améliorer les performances.",
      technologies: ["SQL", "PostgreSQL", "Indexation"]
    },
    {
      id: 9,
      title: "Crowdin",
      year: "2024",
      description: "Application de gestion de traductions développée avec Symfony. Système de rôles (rédacteur, traducteur) avec workflows de validation. Interface intuitive pour la gestion des traductions multilingues.",
      technologies: ["PHP", "Symfony", "MySQL", "Bootstrap"]
    },
    {
      id: 10,
      title: "Application Météo Mobile",
      year: "2024",
      description: "Application mobile météo développée avec React Native et Expo. Utilisation des APIs Open Meteo et Geoapify pour la localisation et les données météo. Interface intuitive avec animations Lottie.",
      technologies: ["React Native", "Expo", "Open Meteo", "Geoapify", "Lottie Icons"]
    }
  ],
  contact: {
    email: "peron_h@etna-alternance.net",
    phone: "+33 6 35 15 73 72",
    social: {
      facebook: "https://www.facebook.com/profile.php?id=100086397202863",
      instagram: "https://www.instagram.com/prn.hugo/",
      linkedin: "https://www.linkedin.com/in/peron-h/",
      youtube: "https://www.youtube.com/@thepouleduzzz8263/featured"
    }
  },
  skills: {
    technical: [
      { name: "HTML & CSS", level: 80 },
      { name: "JavaScript", level: 65 },
      { name: "PHP", level: 45 },
      { name: "SQL", level: 70 },
      { name: "TypeScript", level: 60 },
      { name: "ReactJS", level: 75 },
      { name: "Python", level: 80 },
      { name: "C#", level: 30 },
      { name: "Django", level: 80 },
      { name: "Tests Unitaires", level: 75 },
      { name: "VM Linux", level: 60 },
      { name: "Rédaction Professionnelle", level: 80 },
      { name: "Méthode Agile", level: 75 },
      { name: "Développement Mobile", level: 60 }
    ],
    languages: [
      { name: "Anglais", level: 70 },
      { name: "Français", level: 98 },
      { name: "Allemand", level: 10 }
    ]
  },
  personalInfo: {
    interests: [
      {
        title: "Drone",
        description: "Permis drone semi-professionnel. Drone Mavic 3 Pro. Réalisation de vidéos disponibles sur Instagram."
      },
      {
        title: "Sport",
        description: "Snowboard, ski, judo, école du cirque, roller, escalade, badminton, VTT."
      },
      {
        title: "Travaux manuels",
        description: "Bricolage et rénovation, neuf, ancien, plomberie, charpente, sols, peinture."
      },
      {
        title: "Voyages",
        description: "Île Maurice, île de la Réunion, Etats-Unis, Allemagne, Angleterre, Belgique, Autriche, Espagne, Italie, Corse, République Dominicaine."
      },
      {
        title: "Automobile",
        description: "Passionné d'automobile, bricolage et mécanique."
      }
    ],
    contact: {
      email: "peron_h@etna-alternance.net",
      phone: "+33 6 35 15 73 72",
      social: {
        facebook: "https://www.facebook.com/profile.php?id=100086397202863",
        instagram: "https://www.instagram.com/prn.hugo/",
        linkedin: "https://www.linkedin.com/in/peron-h/",
        youtube: "https://www.youtube.com/@thepouleduzzz8263/featured"
      }
    }
  }
}; 